import { render, staticRenderFns } from "./ItemsCounter.vue?vue&type=template&id=70437668&scoped=true&"
import script from "./ItemsCounter.vue?vue&type=script&lang=js&"
export * from "./ItemsCounter.vue?vue&type=script&lang=js&"
import style0 from "./ItemsCounter.vue?vue&type=style&index=0&id=70437668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70437668",
  null
  
)

export default component.exports